import { render, staticRenderFns } from "./ManagerProfileAvatar.vue?vue&type=template&id=038d90b1&scoped=true"
import script from "./ManagerProfileAvatar.vue?vue&type=script&lang=js"
export * from "./ManagerProfileAvatar.vue?vue&type=script&lang=js"
import style0 from "./ManagerProfileAvatar.vue?vue&type=style&index=0&id=038d90b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d90b1",
  null
  
)

export default component.exports